import { styled } from '@sds-system/system';
import { getAllStyledProps } from '@sds-system/utils';
import type { StyledRowProps } from './Row.types';

export const StyledRow = styled('div')<StyledRowProps>(() => {
  return {
    display: 'flex',
    flexDirection: 'row',
  };
}, getAllStyledProps);
